<template>
  <div class="user" :style="{ height: maxHeight }">
    <!-- <div class="user-banner">
      <img src="@/assets/images/banner.png" alt="" />
    </div> -->
    <div class="user-card">
      <div class="user-msg">
        <div class="user-icon" @click="toPersionInfo">
          <img :src="avatar" alt="" />
        </div>
        <div>
          <div class="user-username">
            {{ userName }}{{ nickName ? ` (${nickName})` : '' }}
          </div>
          <p class="small-font">{{ department }}</p>
        </div>
      </div>
      <div class="user-companyblock">
        <div class="user-company">{{ $t('当前企业：') }}{{ company }}</div>
      </div>
    </div>
    <div class="user-block" v-if="upFace || upKey">
      <div class="user-item" @click="toFaceCollection" v-if="upFace">
        <div class="user-item-left">
          <img src="@/assets/images/face.svg" alt="" />
          <div class="user-item-font">{{ $t('人脸采集') }}</div>
        </div>
        <img src="@/assets/images/dropdownright.svg" alt="" />
      </div>
      <div class="user-item-bottom" @click="toElectronickey" v-if="upKey" :style="{ borderTopWidth: upFace ? 1 : 0 }">
        <div class="user-item-left">
          <img src="@/assets/images/key.svg" alt="" />
          <div class="user-item-font">{{ $t('电子钥匙') }}</div>
        </div>
        <img src="@/assets/images/dropdownright.svg" alt="" />
      </div>
    </div>
    <div class="user-block">
      <!-- <div class="user-item" @click="toAddressBook">
        <div class="user-item-left">
          <img src="@/assets/images/team.png" alt="" />
          <div class="user-item-font">组织成员</div>
        </div>
        <van-icon name="arrow" color="#999999" />
      </div> -->
      <div class="user-item" @click="toSetting">
        <div class="user-item-left">
          <img src="@/assets/images/settingInfo.svg" alt="" />
          <div class="user-item-font">{{ $t('设置') }}</div>
        </div>
        <img src="@/assets/images/dropdownright.svg" alt="" />
      </div>
      <div class="user-item-bottom" @click="onClickVersion">
        <div class="user-item-left">
          <img src="@/assets/images/version.svg" alt="" />
          <div class="user-item-font">{{ $t('版本信息') }}</div>
        </div>
        <span class="versionText">v{{ version }}</span>
      </div>
      <div class="user-item" @click="showLocalesPopup">
        <div class="user-item-left">
          <img src="@/assets/images/version.svg" alt="" />
          <div class="user-item-font">{{ $t('语言') }}</div>
        </div>
        <span class="versionText">{{ localeLabel }}</span>
      </div>

      <van-popup v-model="showLocalePicker" position="bottom">
        <van-picker show-toolbar :columns="locales" @confirm="onLocaleConfirm" @cancel="onLocaleCancel" />
      </van-popup>
    </div>
    <TabBar />
  </div>
</template>
<script>
import TabBar from '@/components/tabBar'
import Vue from 'vue'
import { Icon, Picker, Popup } from 'vant'
import {
  getStaffById,
  getUploadFaceLimits,
  getUploadKeyLimits,
  updateUserLanguage,
  LanguagesRESTful
} from '@/services/api'
import { toggleVConsole } from '@/utils/utils'
import i18n, { LocaleMgr } from 'i18n'


Vue.use(Icon)
Vue.use(Picker)
Vue.use(Popup)

/* i18n-ignore */
const defaultLang = {
  'zh-CN': '简体中文',
  'en-US': 'English',
}

export default {
  name: 'User',
  components: {
    TabBar,
  },
  data() {
    return {
      maxHeight: '100%',
      user: {},
      userName: '',
      department: '',
      company: '',
      nickName: '',
      avatar: null,
      version: process.env.VUE_APP_VERSION,
      res: {},
      upFace: false,
      upKey: false,

      showLocalePicker: false,
      locale: LocaleMgr.highestPriorityFirstLocale,

      allLang: defaultLang
    }
  },
  computed: {
    locales() { return Object.values(this.allLang) },
    localeLabel() {
      return this.allLang[this.locale]
    }
  },
  methods: {
    showLocalesPopup() {
      this.showLocalePicker = true
    },
    onLocaleConfirm(value) {
      let lang
      for (const [k, v] of Object.entries(this.allLang)) {
        if (value === v) lang = k
      }

      if (!lang) return

      LocaleMgr.singleton.setLocale(lang)

      this.locale = lang
      this.showLocalePicker = false
      localStorage.setItem('userLanguage', lang)
      updateUserLanguage({ userId: this.userId, language: lang })
      const usp = new URLSearchParams(window.location.search)

      usp?.delete('localLanguage')

      window.location.search = usp.toString()
    },
    onLocaleCancel() {
      this.showLocalePicker = false
    },
    toSetting() {
      this.$router.push('/setting')
    },
    toFaceCollection() {
      this.$router.push('/faceCollection')
    },
    toAddressBook() {
      this.$router.push('/addressBook')
    },
    toElectronickey() {
      this.$router.push('/electronickey')
    },
    toPersionInfo() {
      this.$router.push('/persionInfo')
    },
    async getAvatar(id) {
      const res = await getStaffById(id)
      res.faceUrl
        ? (this.avatar = res.faceUrl)
        : (this.avatar = require('@/assets/images/icon.png'))
    },
    async fetchUserData() {
      let user = JSON.parse(localStorage.getItem('user'))
      this.res = await getStaffById(user.id)
      this.userName = this.res.name
      this.department = this.res.departmentName
        ? this.res.departmentName.replaceAll(',', '/')
        : ''
      this.nickName = this.res.nickName || ''
    },
    async fetchAllLang() {
      const langParams = {
        // 0 未发布， 1 已发布
        status: 1,
        companyId: this.user.companyId
      }
      const list = await LanguagesRESTful.list(langParams)

      this.allLang = {
        ...defaultLang,
        ...list?.reduce((acc, { code, name }) => ({ ...acc, [code]: name }), {}),
      }
    },
    onClickVersion() {
      // 如果有定时器，清除它
      if (this.timer) {
        clearTimeout(this.timer)
      }

      // 增加点击次数
      this.clickCount++

      // 检查是否达到目标点击次数
      if (this.clickCount === 6) {
        this.clickCount = 0 // 重置点击次数
        toggleVConsole()
      } else {
        // 设置新的超时定时器
        this.timer = setTimeout(() => {
          this.clickCount = 0 // 超时后重置点击次数
        }, 500)
      }
    },
    handleResize() {
      this.maxHeight = window.innerHeight - 68 + 'px'
    },
  },
  mounted() {
    this.userId = JSON.parse(localStorage.getItem('user'))?.id
    this.clickCount = 0
    this.fetchUserData()
    this.user = JSON.parse(localStorage.getItem('user'))
    this.company = this.user.companyName
    this.getAvatar(this.user.id)
    if (this.user.companyId) {
      getUploadFaceLimits({ companyId: this.user.companyId }).then((res) => {
        this.upFace = res
      })
      getUploadKeyLimits({ companyId: this.user.companyId }).then((res) => {
        this.upKey = res
      })
    }
    if (!this.user.departmentName) {
      fetchUserData()
    } else {
      this.department = this.user.departmentName
        ? this.user.departmentName.replaceAll(',', '/')
        : ''
    }
    this.maxHeight = window.innerHeight + 'px'
    window.addEventListener('resize', this.handleResize)
    this.fetchAllLang()
  },
  destroyed() {
    // 清除定时器
    if (this.timer) {
      clearTimeout(this.timer)
    }
  },
}
</script>
<style lang="less" scoped>
.user {
  // height: 100%;
  // background: #f9f9f9;
  padding: 0 12px;
  background: url('../../assets/images/useBackground.png');

  .user-banner {
    margin-bottom: 100px;

    img {
      width: 100%;
    }
  }

  .user-card {
    width: 100%;
    // height: 193px;
    padding-top: 44px;
    padding-left: 12px;

    .user-msg {
      // height: 98px;
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .user-icon {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 16px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .user-username {
      font-family: AlibabaPuHuiTi_2_85_Bold;
      font-size: 20px;
      color: #1e2329;
      line-height: 28px;
      margin-bottom: 4px;
    }

    .small-font {
      font-family: AlibabaPuHuiTi_2_55_Regular;
      font-size: 14px;
      color: #707a8a;
      line-height: 20px;
      white-space: nowrap;
      overflow: hidden;
      max-width: 200px;
      text-overflow: ellipsis;
    }

    .user-companyblock {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
    }

    .user-company {
      font-family: AlibabaPuHuiTi_2_55_Regular;
      font-size: 14px;
      color: #707a8a;
      line-height: 20px;
      width: 340px;
      white-space: nowrap;
      overflow: hidden;
      max-width: 200px;
      text-overflow: ellipsis;
    }
  }

  .user-block {
    width: 351px;
    background: #ffffff;
    border-radius: 8px;
    padding: 4px 13px 4px 18px;
    margin-bottom: 12px;
  }

  .user-item {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // padding: 0px 13px 0px 18px;
  }

  .user-item-bottom {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // padding: 0px 13px 0px 18px;
    border-top: 1px solid rgba(234, 236, 239, 0.5);
  }

  .user-item-left {
    display: flex;
    align-items: center;
    // font-size: 16px;
    // line-height: 24px;

    img {
      height: 20px;
      width: 20px;
    }

    .user-item-font {
      margin-left: 10px;
      white-space: nowrap;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #1e2329;
    }
  }

  .versionIcon {
    color: #009bff;
    font-weight: 500;
  }

  .versionText {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #1e2329;
  }
}
</style>
